import { Button, Card, Space } from 'antd';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../components/ResponsiveContainer';
import EmpresaContext from '../context/empresa-context';

function AdminConfig() {
  const history = useHistory();
  const { empresa } = useContext(EmpresaContext);
  const aseguradora = async () => {
    history.push(`/admin-aseguradora`);
  };

  const empresaConfig = async () => {
    history.push(`/admin-empresa`);
  };

  return (
    <ResponsiveContainer size="large">
      <Card title="Administración" style={{ textAlign: 'left' }}>
        <Space direction="vertical">
          {empresa && empresa.id_aseguradora && (
            <Button type="link" onClick={aseguradora}>
              Administración de la Aseguradora
            </Button>
          )}
          <Button type="link" onClick={empresaConfig}>
            Administración de la Empresa
          </Button>
        </Space>
      </Card>
    </ResponsiveContainer>
  );
}

export default AdminConfig;
